import { jsx as o, Fragment as h, jsxs as m } from "@emotion/react/jsx-runtime";
import { IllustrationCategoryEnum as I } from "@partoohub/iconography";
import { DialogContainer as k, StyledIconButtonBack as b, StyledIconButtonClose as v, DialogContent as B, DialogTitle as E, DialogSubtitle as S } from "./Dialog.styled.js";
import { DialogFooter as w } from "./DialogFooter.tsx/DialogFooter.js";
import { DialogHeader as x, isElementOfType as C } from "./DialogHeader/DialogHeader.js";
import { Stack as F } from "../Stack/index.js";
import { FontAwesomeIconsPartooUsed as d } from "../../types/components/icon.js";
const R = ({
  dataTrackId: i,
  headerContent: a,
  title: r,
  subTitle: t,
  children: p,
  size: u = "medium",
  show: g = !0,
  onClose: e,
  onBack: n,
  className: f,
  actions: y
}) => {
  const l = ((D) => C(D, I, ["type", "name"]))(a) || !a, c = l ? "outlined" : "contained", s = l ? "secondary" : "theme";
  return /* @__PURE__ */ o(h, { children: g && /* @__PURE__ */ m(k, { size: u, className: f, children: [
    /* @__PURE__ */ o(x, { dataTrackId: i, headerContent: a }),
    n && /* @__PURE__ */ o(b, { "aria-label": "Back", dataTrackId: `${i}-dialog-back`, icon: [d.faArrowLeft], appearance: c, variant: s, onClick: n }),
    e && /* @__PURE__ */ o(v, { "aria-label": "Close", dataTrackId: `${i}-dialog-close`, icon: [d.faClose], appearance: c, variant: s, onClick: e }),
    /* @__PURE__ */ m(B, { header: !!a, children: [
      r && /* @__PURE__ */ o(E, { variant: "heading4", as: "p", children: r }),
      t && /* @__PURE__ */ o(S, { variant: "bodyMRegular", as: "div", color: "secondary", children: t }),
      /* @__PURE__ */ o(F, { direction: "column", style: {
        width: "100%"
      }, children: p })
    ] }),
    /* @__PURE__ */ o(w, { actions: y, hasHeader: !!a })
  ] }) });
};
export {
  R as Dialog
};
